<script>
import { mapState } from 'vuex';

export default {
  props: {
    text: {
      default: '',
    },
  },
  computed: {
    ...mapState(['errorMessage']),
  },
};
</script>
<template>
  <p v-if="text" class="text-red font-semibold">
    <em v-html="text"></em>
    <template v-if="errorMessage">
      <br class="hidden sm:block">
      <router-link
        :to="{ name: 'Troubleshoot' }"
        class="text-sm underline hover:text-orange-dark focus:text-orange-dark"
      >{{ $t('contactSupport') }}</router-link>
    </template>
  </p>
</template>
